import { useCallback, useEffect, useState } from "react"
import { styled } from "@mui/material/styles"
import { useLocation } from "react-router"
import TopNav from "./components/TopNav"
import SideNav from "./components/SideNav"
import { SIDE_NAV_COLLAPSED_WIDTH } from "./constants"

const LayoutRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  [theme.breakpoints.up("lg")]: {
    paddingLeft: SIDE_NAV_COLLAPSED_WIDTH
  }
}))

const LayoutContainer = styled("div")({
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  width: "100%",
  padding: "24px 32px",
  minHeight: "calc(100vh - 64px)"
})

export const AdminLayout = (props) => {
  const { children } = props
  const { pathname } = useLocation()
  const [openNav, setOpenNav] = useState(false)

  const handlePathnameChange = useCallback(() => {
    if (openNav) {
      setOpenNav(false)
    }
  }, [openNav])

  useEffect(() => {
    handlePathnameChange()
  }, [pathname])

  return (
    <>
      <TopNav onNavOpen={() => setOpenNav(true)} />
      <SideNav onClose={() => setOpenNav(false)} open={openNav} />
      <LayoutRoot>
        <LayoutContainer>{children}</LayoutContainer>
      </LayoutRoot>
    </>
  )
}
